
webpack.register(
    'modules/history-experience-scoring-and-stats/stats/stats',
    function() {
        return import('modules/history-experience-scoring-and-stats/stats/stats');
    },
    true
);